import React from "react";
import { BusinessPage } from "../shared/BusinessPage";
import { Timetable } from "../Dashboard/block/Timetable/Timetable";

export default function SchedulePage() {
    return <BusinessPage title="Расписание" subtitle="Планируйте смены команды на месяц.">
        <Timetable planning />
    </BusinessPage>;
}
